import "core-js/modules/es.array.push.js";
export default (function (activeIndex, limit) {
  var halfLimit = Math.floor(limit / 2);
  var lowLimit = Math.max(activeIndex - halfLimit, 0);
  var highLimit = activeIndex + (limit - halfLimit);
  var activeSlides = [];
  for (var index = lowLimit; index <= highLimit; index += 1) {
    activeSlides.push(index);
  }
  return activeSlides;
});